var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('title-row', {
    attrs: {
      "title": "Rendszám lekérdezés",
      "breadcrumb-items": [{
        text: 'Rendszám lekérdezés',
        disabled: true
      }]
    }
  }), _c('v-expansion-panels', {
    staticClass: "mb-4 rounded-xl overflow-hidden",
    attrs: {
      "mandatory": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('span', {
    staticClass: "font-weight-medium"
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v(" Keresés ")], 1)]), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": 4
    }
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Rendszám",
      "dense": "",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "click:clear": _vm.clearResults
    },
    model: {
      value: _vm.searchQuery,
      callback: function ($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": 2
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Lekérdezés")])], 1)], 1)], 1)], 1)], 1), _vm.isLoading ? _c('div', {
    staticClass: "text-center my-4"
  }, [_c('v-skeleton-loader', {
    staticClass: "rounded-xl",
    attrs: {
      "type": "article"
    }
  })], 1) : _vm._e(), _vm.plates.length > 0 ? _c('div', [_c('h2', {
    staticClass: "my-4"
  }, [_vm._v("Összesített parkolás jogosultságok")]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "card-content"
  }, _vm._l(_vm.parkingAreas, function (area) {
    return _c('v-chip', {
      key: area,
      staticClass: "ma-1",
      attrs: {
        "color": _vm.mergedParkingAreas.includes(area) ? 'green' : 'red',
        "text-color": "white"
      }
    }, [_vm._v(" " + _vm._s(area) + " ")]);
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm.plates.length > 0 ? _c('h2', {
    staticClass: "my-4"
  }, [_vm._v("Kártyák (" + _vm._s(_vm.plates.length) + ")")]) : _vm._e(), _c('v-row', _vm._l(_vm.plates, function (plate) {
    return _c('v-col', {
      key: plate.id,
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [_c('v-card', {
      staticClass: "rounded-xl",
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', [_c('div', {
      staticClass: "mr-2"
    }, [_c('strong', [_vm._v("Kártyaszám:")]), _vm._v(" " + _vm._s(plate.card_number))]), _c('v-badge', {
      attrs: {
        "inline": "",
        "color": plate.active === '1' ? 'green' : 'red'
      }
    })], 1), _c('v-card-text', {
      staticClass: "card-content"
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('div', [_c('strong', [_vm._v("Tulajdonos:")]), _vm._v(" " + _vm._s(plate.owner_name))]), _c('div', [_c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(plate.email))]), _c('div', [_c('strong', [_vm._v("Rendszám:")]), _vm._v(" " + _vm._s(plate.number))]), _c('div', [_c('strong', [_vm._v("Kártya ID:")]), _vm._v(" " + _vm._s(plate.card_id))]), _c('div', [_c('strong', [_vm._v("Aktív:")]), _vm._v(" " + _vm._s(plate.active === '1' ? 'Igen' : 'Nem'))])]), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('div', [_c('strong', [_vm._v("Parkolási jogosultságok:")]), plate.parking_areas && plate.parking_areas.length > 0 && plate.active === '1' ? _c('div', {
      staticClass: "chip-container"
    }, _vm._l(_vm.parkingAreas, function (area) {
      return _c('v-chip', {
        key: area,
        staticClass: "ma-1",
        attrs: {
          "color": plate.parking_areas.includes(area) ? 'green' : 'red',
          "text-color": "white",
          "small": ""
        }
      }, [_vm._v(" " + _vm._s(area) + " ")]);
    }), 1) : _c('div', [_vm._v("Nincs parkolási jogosultság / nem aktív a kártya")])])])], 1)], 1)], 1)], 1);
  }), 1), _vm.seasonTickets && _vm.seasonTickets.length > 0 ? _c('div', [_c('h2', {
    staticClass: "my-4"
  }, [_vm._v("Bérletek (" + _vm._s(_vm.seasonTickets.length) + ")")]), _c('v-row', _vm._l(_vm.seasonTickets, function (ticket) {
    return _c('v-col', {
      key: ticket.id,
      staticClass: "rounded-xl",
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [_c('v-card', {
      staticClass: "rounded-xl"
    }, [_c('v-card-title', [_c('div', [_c('strong', [_vm._v("Bérlet ID:")]), _vm._v(" " + _vm._s(ticket.id))])]), _c('v-card-text', [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('div', [_c('strong', [_vm._v("Kártyaszám:")]), _vm._v(" " + _vm._s(ticket.card_number))]), _c('div', [_c('strong', [_vm._v("Érvényesség kezdete:")]), _vm._v(" " + _vm._s(new Date(ticket.validation_date).toLocaleDateString()) + " ")]), _c('div', [_c('strong', [_vm._v("Érvényesség vége:")]), _vm._v(" " + _vm._s(new Date(ticket.validity_end).toLocaleDateString()) + " ")])]), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('div', [_c('strong', [_vm._v("Parkolási jogosultságok:")]), _vm.seasonTicketParkingAreas(ticket).length > 0 ? _c('div', {
      staticClass: "chip-container"
    }, _vm._l(_vm.parkingAreas, function (area) {
      return _c('v-chip', {
        key: area,
        staticClass: "ma-1",
        attrs: {
          "color": _vm.seasonTicketParkingAreas(ticket).includes(area) ? 'green' : 'red',
          "text-color": "white",
          "small": ""
        }
      }, [_vm._v(" " + _vm._s(area) + " ")]);
    }), 1) : _c('div', [_vm._v("Nincs parkolási jogosultság")])])])], 1)], 1)], 1)], 1);
  }), 1)], 1) : _vm._e(), _vm.barcodes && _vm.barcodes.length > 0 ? _c('div', [_c('h2', {
    staticClass: "my-4"
  }, [_vm._v("Vonalkódok (" + _vm._s(_vm.barcodes.length) + ")")]), _c('v-row', _vm._l(_vm.barcodes, function (barcode) {
    return _c('v-col', {
      key: barcode.barcode_number,
      staticClass: "rounded-xl",
      attrs: {
        "cols": "12",
        "xs": "12",
        "lg": "6"
      }
    }, [_c('v-card', {
      staticClass: "rounded-xl"
    }, [_c('v-card-title', [_c('div', [_c('strong', [_vm._v("Vonalkód:")]), _vm._v(" " + _vm._s(barcode.barcode_number))])]), _c('v-card-text', [_c('div', [_c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(barcode.email))]), _c('div', [_c('strong', [_vm._v("RFID:")]), _vm._v(" " + _vm._s(barcode.rf_id))]), _c('div', [_c('strong', [_vm._v("Hozzárendelve:")]), _vm._v(" " + _vm._s(barcode.start_date_time ? new Date(barcode.start_date_time).toLocaleString() : 'Null érték') + " ")]), _c('div', [_c('strong', [_vm._v("Lejárat:")]), _vm._v(" " + _vm._s(barcode.end_date ? new Date(barcode.end_date).toLocaleString() : 'Nincs') + " ")])])], 1)], 1);
  }), 1)], 1) : _vm._e(), _vm.logs.length > 0 ? _c('h2', {
    staticClass: "my-4"
  }, [_vm._v("Rendszámhoz tartozó logok")]) : _vm._e(), _vm.logs.length > 0 ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 rounded-xl",
    attrs: {
      "headers": [{
        text: 'ID',
        value: 'logid'
      }, {
        text: 'Név',
        value: 'displayname'
      }, {
        text: 'Email',
        value: 'email'
      }, {
        text: 'Kapu',
        value: 'gate_name'
      }, {
        text: 'Esemény típusa',
        value: 'type'
      }, {
        text: 'Esemény időpontja',
        value: 'created'
      }],
      "items": _vm.logs
    },
    scopedSlots: _vm._u([{
      key: "item.email",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s(item.email ? item.email : item.barcode_email))])];
      }
    }], null, false, 1223293010)
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }